import { Button, Form, Space, Tabs } from "antd";
import { useEffect, useRef, useState } from "react";
import axios from "utils/axios";
import configFile from "config.json";
import { NotificationManager } from "react-notifications";
import MenuTable from "components/Table/MenuTable";
import { SelectStore } from "components/Form/InputTypes";
import styled from "styled-components";
import CreateConfigModal from "components/Modal/CreateConfigModal";

const Menus = () => {
  const [data, setData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [store, setStore] = useState(null);
  const [form] = Form.useForm();
  const [tabItem, setTabItem] = useState(null);
  const [editForm] = Form.useForm();

  const [tableHeight, setTableHeight] = useState("100vh");
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState()
  const headerRef = useRef(null);


  const fetchData = async () => {
    try {
      const {
        data: { data: menus },
      } = await axios.post(`${configFile.PROD_SERVER_URL}/menu/getMenus`, {
        storeName: store,
      });
      const menuItem = ['Beverage', 'CC', 'Condiments', 'Deal', 'Meal', 'Dessert', 'Pizza', 'Snack', 'Combo', 'Others', 'Sample', 'Side'];
      const filteredMenus = Object.keys(menus).reduce((acc, key) => {
        if (menuItem.includes(key)) {
          acc[key] = menus[key];
        }
        return acc;
      }, {});
      setData(filteredMenus);
    } catch (error) {
      NotificationManager.error(
        error.response.data.errorMessage,
        "Error",
        5000
      );
      console.log(error);
    }
  };
  useEffect(() => {
    setData(null);
    setTabItem(null);
    setTableData([]);

    if (store) fetchData();
    return () => {
      setTableData([]);
    };
  }, [store]);

  useEffect(() => {
    if (!data) return;

    const keys = Object.keys(data);
    if (!keys.length) return;

    const nextTab = tabItem && data[tabItem] ? tabItem : keys[0];

    setTabItem(nextTab);
    onChangeTab(nextTab);
  }, [data]);

  useEffect(() => {
    const node = headerRef.current;
    const { top } = node.getBoundingClientRect();
    // normally TABLE_HEADER_HEIGHT would be 55.
    setTableHeight(window.innerHeight - top);
  }, [headerRef]);

  const handleStore = (item) => {
    setStore(item);
  };

  const onChangeTab = (e) => {
    setTabItem(e);
    if (e === "Pizza" || e === "CC") {
      let datas = [];
      Object.keys(data[e])?.map((field) => {
        data[e][field].items.map((item) =>
          datas.push({
            ...item,
            key: item.menuItemDefID ?? item.miMasterObjNum,
          })
        );
      });
      setTableData(datas);
    } else {
      const mappedData = data[e]?.map((item, index) => {
        return { ...item, key: item.menuItemDefID ?? item.miMasterObjNum ?? index + 1, };
      });
      setTableData(mappedData);
    }
  };

  const showEditModal = (record) => {
    setSelectedRecord({ ...record, store });
    setIsCreateModalOpen(true);
  };

  const handleEditCancel = () => {
    setIsCreateModalOpen(false);
    setSelectedRecord(null);
    editForm.resetFields();
  };


  const formatTug = (value) => {
    if (value === null || value === undefined) return "";
    return value.toLocaleString("mn-MN") + " ₮";
  };

  const tableMenusWithConfig = [
    {
      title: "masterName",
      dataIndex: "masterName",
      onFilter: (value, record) => record["masterName"].indexOf(value) === 0,
      rowScope: "row",
      width: 200,
    },
    {
      title: "Action",
      key: "action",
      width: 150,
      fixed: "right",
      render: (_, record) => {
        if (tabItem === "Combo") return null;
        return (
          <Space>
            <Button type="link" onClick={() => showEditModal(record)}>
              Edit
            </Button>
          </Space>
        )
      },
    },
    {
      title: "overPrice",
      dataIndex: "overPrice",
      sorter: (a, b) => a["overPrice"] - b["overPrice"],
      render: (value) => {
        console.log(value, 'valllllll');
        return (
          formatTug(value)
        )
      },
      width: 120,
    },
    {
      title: "hasConfig",
      dataIndex: "hasConfig",
      onFilter: (value, record) =>
        record.masterName
          ?.toString()
          .toLowerCase()
          .indexOf(value.toString().toLowerCase()) === 0,
      render: (text, record) => (
        <p style={{ color: record.hasConfig ? 'green' : 'red' }}>
          {record.hasConfig ? 'Тохиргоо хийгдсэн' : 'Тохиргоо хийгдэгүй'}
        </p>
      ),
      width: 120,
    },
    {
      title: "show",
      dataIndex: "show",
      render: (text, record) => (
        <p style={{ color: record.show ? 'green' : 'red' }}>
          {record.show ? 'Харагдана' : 'Нуусан'}
        </p>
      ),
      width: 120,
    },
    {
      title: "price",
      dataIndex: "price",
      sorter: (a, b) => a["price"] - b["price"],
      render: (value) => formatTug(value),
      width: 120,
    },
    {
      title: "miMasterObjNum",
      dataIndex: "miMasterObjNum",
      sorter: (a, b) => a["miMasterObjNum"] - b["miMasterObjNum"],
      width: 180,
    },
    {
      title: "menuItemDefID",
      dataIndex: "menuItemDefID",
      width: 150,
    },
    {
      title: "longDescriptor_stringText",
      dataIndex: "longDescriptor_stringText",
      width: 200,
    },
    {
      title: "familyGroup",
      dataIndex: "familyGroup",
      onFilter: (value, record) => record["familyGroup"].indexOf(value) === 0,
      width: 160,
    },
    {
      title: "familyGroupId",
      dataIndex: "familyGroupId",
      onFilter: (value, record) => record["familyGroupId"].indexOf(value) === 0,
      sorter: (a, b) => a["familyGroupId"] - b["familyGroupId"],
      width: 160,
    },
    {
      title: "majorGroup",
      dataIndex: "majorGroup",
      onFilter: (value, record) => record["majorGroup"].indexOf(value) === 0,
      sorter: (a, b) => a["majorGroup"] - b["majorGroup"],
      width: 160,
    },
    {
      title: "majorGroupId",
      dataIndex: "majorGroupId",
      onFilter: (value, record) => record["majorGroupId"].indexOf(value) === 0,
      width: 160,
    },
    {
      title: "menuItemMasterID",
      dataIndex: "menuItemMasterID",
      sorter: (a, b) => a["menuItemMasterID"] - b["menuItemMasterID"],
      width: 180,
    },
    {
      title: "type",
      dataIndex: "type",
      width: 120,
    },
    {
      title: "subLevelsHex",
      dataIndex: "subLevelsHex",
      width: 200,
    },
  ];

  // const handleUpdateMenu = async () => {
  //   try {
  //     const {
  //       data: {
  //         data: { data: menus },
  //       },
  //     } = await axios.post(
  //       `${configFile.PROD_SERVER_URL}/menu/updateMenusFromStore`,
  //       {
  //         storeName: store,
  //       }
  //     );
  //     NotificationManager.success("Амжилттай татагдлаа", 5000);
  //     fetchData();
  //   } catch (error) {
  //     NotificationManager.error(
  //       error.response.data.errorMessage,
  //       "Error",
  //       5000
  //     );
  //     console.log(error);
  //   }
  // };
  return (
    <Form form={form}>
      <Container>
        <div className="header" ref={headerRef}>
          <div className="top">
            <SelectStore
              style={{ minWidth: "300px" }}
              form={form}
              name="store"
              onChange={handleStore}
            />
            {/* <Button
              disabled={!store ? true : false}
              key="back1"
              onClick={handleUpdateMenu}
            >
              Салбараас меню татах
            </Button> */}
          </div>
          {data && data.length !== 0 && (
            <Tabs
              type="card"
              activeKey={tabItem}
              items={Object.keys(data)?.map((field) => {
                return {
                  label: field,
                  key: field,
                };
              })}
              onChange={onChangeTab}
            />
          )}
        </div>
        <MenuTable
          height={tableHeight}
          columns={tableMenusWithConfig}
          dataSource={tableData}
          menu={tabItem}
        />
        <CreateConfigModal
          open={isCreateModalOpen}
          onCancel={() => handleEditCancel()}
          refetch={fetchData}
          propsData={selectedRecord}
          record={selectedRecord}
        />
      </Container>
    </Form>
  );
};
const Container = styled.div`
  .top {
    display: flex;
    gap: 20px;
  }
`;
export default Menus;
